/**
 * SEO fields for the sign-in page, used by `pages/login/index.tsx` and, unchanged, by
 * `pages/easy-quote/index.tsx`, so the Easy Quote page's title and canonical URL are the sign-in
 * page's. The `fr` and `es` entries repeat the English text.
 */
import { LanguageContent } from "@components/Shared/model/LanguageContent";
import { MetaContent } from "@components/Shared/model/MetaHead";
import { StaticPageContent } from "@components/Shared/model/StaticPageContent";

/** `MetaHead` content for `/login`, per language. */
export const LoginMetaObject: LanguageContent<MetaContent> = {
	en: {
		title: "Account Login - Ryerson",
		description: `Login to your Ryerson account to manage your account, create shopping lists, check order status, and more`,
		url: `/login`,
		company: true,
	},
	fr: {
		title: "Account Login - Ryerson",
		description: `Login to your Ryerson account to manage your account, create shopping lists, check order status, and more`,
		url: `/login`,
		company: true,
	},
	es: {
		title: "Account Login - Ryerson",
		description: `Login to your Ryerson account to manage your account, create shopping lists, check order status, and more`,
		url: `/login`,
		company: true,
	},
};

/**
 * The sign-in page's entry in the site search index (`scripts/staticSearch.ts`). Only the meta is
 * searchable: `content` is empty.
 */
export const LoginPageContent: StaticPageContent = {
	meta: LoginMetaObject,
	content: [],
};
